<div class="progress-bar">
   <div *ngIf="progress > 0">
      <progressbar
         [max]="100"
         [value]="progress"
         [type]="progressBarType"
         [striped]="true"
         [animate]="true"
         ><i>{{
            progress === 100 ? ('Successful download' | translate) : progress + '%'
         }}</i></progressbar
      >
   </div>
</div>
<div *ngIf='canDownloadDocs' class="card border-dark">
   <div class="card-header">
      <form class="form-inline">
         <b>{{ 'Legal notices' | translate }}</b>
      </form>
   </div>
   <div class="card-body">
      <div class="document-downloads">
         <div class="document-download-item">
            {{ 'Terms and Conditions' | translate }}:
            <lib-icon
               [content]="icons.download"
               [libTooltip]="'Download' | translate"
               (iClicked)="downloadDoc('aszf')"
            ></lib-icon>
         </div>
         <div class="document-download-item">
            {{ 'Privacy Policy' | translate }}:
            <lib-icon
               [content]="icons.download"
               [libTooltip]="'Download' | translate"
               (iClicked)="downloadDoc('privacypolicy')"
            ></lib-icon>
         </div>
      </div>
   </div>
</div>
<lib-table
   *ngIf="canDownloadDocs"
   [headers]="portalHeaders"
   [codes]="portalCodes"
   [rows]="portalReleases"
   [readOnly]="true"
   [search]="false"
   (iconEvent)="onIconClick($event)"
   [label]="'Portal releases' | translate"
>
</lib-table>

<lib-table
   [headers]="appHeaders"
   [codes]="appCodes"
   [rows]="appReleases"
   [readOnly]="true"
   [search]="false"
   (iconEvent)="onIconClick($event)"
   [label]="'Application releases' | translate"
>
</lib-table>
